import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter } from 'events';

@Component({
  selector: 'app-consulta-controle-societario',
  templateUrl: './consulta-controle-societario.component.html',
  styleUrls: ['./consulta-controle-societario.component.scss']
})
export class ConsultaControleSocietarioComponent implements OnInit {
  title = "CONTROLE SOCIETÁRIO";

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
    if(this.codigoControle == "SEMREGISTRO_OK") {
      this.status = 'success';
    }
  }

}
